


























import Vue from "vue";
import Component from "vue-class-component";

export interface PrecheckLeaveAlertResult {
  ok: boolean;
  suppressToday: boolean;
}

@Component
export default class PrecheckLeaveAlertDialog extends Vue {
  private suppressToday = false;
  private isOpen = false;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private _resolve: (result: PrecheckLeaveAlertResult) => void = () => {};

  public async open(): Promise<PrecheckLeaveAlertResult> {
    this.suppressToday = false;
    return new Promise(resolve => {
      this.isOpen = true;
      this._resolve = resolve;
    });
  }

  private close() {
    this.isOpen = false;
  }

  private cancel() {
    this._resolve({ ok: false, suppressToday: this.suppressToday });
    this.close();
  }

  private ok() {
    this._resolve({ ok: true, suppressToday: this.suppressToday });
    this.close();
  }
}
